import { render, staticRenderFns } from "./mobilePreview.vue?vue&type=template&id=70e6375b&"
import script from "./mobilePreview.vue?vue&type=script&lang=js&"
export * from "./mobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./mobilePreview.vue?vue&type=style&index=0&id=70e6375b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports